<template>
  <BaseContainer
    tag="footer"
    class="jps-global-jps-footer"
    role="contentinfo"
  >
    <BaseLink to="/" class="footer-logo">
      <BaseIcon
        name="jps/logo-horizontal-4c-w"
        alt="ジャパンサーチ"
        size="size-full"
        class="generated-8"
      />
    </BaseLink>

    <div class="jps-global-jps-footer-body">
      <ul class="jps-global-jps-footer-stripes">
        <li>
          <BaseLink class="footer-strip-item" to="/gallery">
            <h2 class="">{{ lss('ギャラリー', 'Gallery') }}</h2>
            <p class="">
              {{
                lss(
                  'テーマや人物の資料を楽しむ',
                  'Enjoy contents along various theme',
                )
              }}
            </p>
          </BaseLink>
        </li>
        <li>
          <BaseLink class="footer-strip-item" to="/database">
            <h2 class="">
              {{ lss('データベースを見つける', 'Databases') }}
            </h2>
            <p class="">
              {{
                lss(
                  '連携しているデータベースを探す',
                  'Find databases connected to Japan Search',
                )
              }}
            </p>
          </BaseLink>
        </li>
        <li>
          <BaseLink class="footer-strip-item" to="/csearch">
            <h2 class="">
              {{ lss('テーマ別検索機能を使う', 'Designed Searches') }}
            </h2>
            <p class="">
              {{
                lss(
                  '目的・分野毎に最適化された検索',
                  'Search for specific topics or databases',
                )
              }}
            </p>
          </BaseLink>
        </li>
        <li>
          <BaseLink class="footer-strip-item" to="/organization">
            <h2 class="">
              {{ lss('施設・機関を見つける', 'Organizations') }}
            </h2>
            <p class="">
              {{
                lss(
                  'ジャパンサーチと連携している組織',
                  'Find partner institutions',
                )
              }}
            </p>
          </BaseLink>
        </li>
      </ul>

      <div class="jps-global-jps-footer-nav-group">
        <div class="layout-column">
          <ul class="jps-global-jps-footer-nav">
            <li>
              <BaseLink to="/about">{{
                lss('ジャパンサーチの概要', 'About Japan Search')
              }}</BaseLink>
            </li>
            <li>
              <BaseLink to="/help">{{ lss('ヘルプ', 'Help') }}</BaseLink>
            </li>
            <li>
              <BaseLink to="/news">{{ lss('お知らせ', 'Notice') }}</BaseLink>
            </li>
            <li>
              <BaseLink to="/policy">{{ lss('サイトポリシー', 'Site policies') }}</BaseLink>
            </li>
            <li>
              <BaseLink to="/contact" :same-page-force-reload="true">{{ lss('お問い合わせ', 'Contact us') }}</BaseLink>
            </li>
          </ul>
          <ul class="jps-global-jps-footer-nav">
            <li>
              <BaseLink to="/cooperation">{{
                lss(
                  '連携をご希望の機関の方へ',
                  'For Institutions Interested in Cooperating',
                )
              }}</BaseLink>
            </li>
            <li>
              <a
                :href="
                  lss(
                    `${config.public.staticFileBaseUrl}/developer/ja.html`,
                    `${config.public.staticFileBaseUrl}/developer/en.html`,
                  )
                "
                >{{ lss('開発者の方へ', 'For Developers') }}</a>
            </li>
            <li>
              <a
                :href="
                  lss(
                    `${config.public.staticFileBaseUrl}/jps-lab/`,
                    `${config.public.staticFileBaseUrl}/jps-lab/`,
                  )
                "
                >{{ lss('ジャパンサーチラボ', 'Japan Search Labo') }}</a>
            </li>
          </ul>
        </div>
        <ul class="jps-global-jps-footer-sns-list">
          <li>
            <a
              href="https://www.youtube.com/channel/UCSK72iSEQMzEcu8BWLEFzPQ"
              class="footer-sns-list-link"
            >
              <BaseIcon name="brand/youtube" class="footer-sns-list-icon" />YouTube
            </a>
          </li>
          <li>
            <a
              href="https://www.facebook.com/jpsearchgo/"
              class="footer-sns-list-link"
            >
              <BaseIcon name="brand/facebook" class="footer-sns-list-icon" />Facebook
            </a>
          </li>
          <li>
            <a href="https://twitter.com/jpsearch_go" class="footer-sns-list-link">
              <BaseIcon name="brand/x" class="footer-sns-list-icon" />
              X
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/japansearch_go/"
              class="footer-sns-list-link"
            >
              <BaseIcon name="brand/instagram" class="footer-sns-list-icon" />Instagram
            </a>
          </li>
        </ul>
      </div>

      <div class="jps-global-jps-footer-about-digital-archive">
        <a
          href="https://www.cas.go.jp/jp/seisakukaigi/titeki2/digitalarchive_suisiniinkai/index.html"
        >{{
          lss(
            'デジタルアーカイブ推進に関する検討会',
            'Study Group for Promoting Digital Archiving',
          )
        }}</a>
      </div>
    </div>
  </BaseContainer>
</template>

<script lang="ts" setup>
const { lss } = useI18n()
const config = useRuntimeConfig()
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;
@use "sass:color";

.jps-global-jps-footer {
  background-color: $jps-gray-900;
  padding-top: 2rem;
  padding-bottom: 2rem;
  color: $white;

  .footer-logo {
    display: block;
    width: 12rem;
    margin: 0 auto;

    @include is-tablet {
      width: 256px;
    }

    .generated-8 {
      height: 100%;
      width: 100%;
    }
  }
}

.jps-global-jps-footer-body {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-top: 1rem;
}

.jps-global-jps-footer-stripes {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  gap: 1rem;

  @include is-mobile {
    flex-direction: column;
    margin-bottom: 0.5rem;
  }

  li {
    flex: 1 0 auto;
  }

  .footer-strip-item {
    display: block;
    border-radius: 0.5rem;
    border: 1px solid $jps-gray-800;
    outline: 1px solid transparent;
    outline-offset: 4px;
    background-color: $jps-gray-800;
    padding: calc(0.25rem * 4) calc(0.25rem * 3);
    color: $white;

    &:hover {
      color: $white;
      outline-color: $jps-gray-400;
    }

    &:focus, &:active {
      outline-color: $jps-gray-400;
      text-decoration: underline;
    }

    h2 {
      //font-size: 1rem;
      //line-height: 1.5;
      font-size: 1.125rem;
      line-height: 1.75rem;
      font-weight: 700;
      color: $white;
      margin-top: 0;
      margin-bottom: 0;
    }
    p {
      font-size: 0.75rem;
      //line-height: calc(1.75 / 1.25);
      line-height: 1rem;
      color: $white;
      margin-top: 0.25rem;
    }
  }
}

.jps-global-jps-footer-nav-group {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 1.5rem;

  @include is-tablet {
    gap: 1rem;
    flex-direction: row;
    justify-content: space-between;
  }
}

.jps-global-jps-footer-nav {
  display: flex;
  flex-direction: column;
  align-items: center;

  @include is-tablet {
    flex-direction: row;
    gap: 1rem;
  }

  & + & {
    @include is-mobile {
      margin-top: 0.5rem;
    }
  }

  a {
    display: block;
    padding: 0.25rem 0;
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: $white;

    &:hover, &:focus {
      color: $white;
      text-decoration: underline;
    }

    &:any-link {
      color: $white;
    }
  }
}

.jps-global-jps-footer-sns-list {
  display: flex;
  flex-direction: row;
  gap: 1rem;

  @include is-mobile {
    flex-wrap: wrap;
    margin-left: auto;
    margin-right: auto;
  }

  @include is-tablet {
    margin-left: auto;
    margin-right: 0;
  }

  .footer-sns-list-link {
    display: flex;
    align-items: center;
    line-height: 1.25rem;
    color: $white;

    &:hover, &:focus {
      color: $white;
      text-decoration: underline;
    }

    &:any-link {
      color: $white;
    }

    @include is-mobile {
      font-size: $size-8;
    }

    @include is-tablet {
      font-size: $size-7;
    }
  }

  .footer-sns-list-icon {
    margin-right: 0.25rem;
  }
}

.jps-global-jps-footer-about-digital-archive {
  text-align: center;
  font-size: 0.875rem;
  line-height: 1.25rem;

  a {
    color: $white;

    &:hover, &:focus {
      color: $white;
      text-decoration: underline;
    }

    &:any-link {
      color: $white;
    }
  }
}
</style>
